export const landingPageStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		height: '100%',
		pt: '14vh'
	},
	appLogo: {
		width: '450px',
		maxWidth: '100%',
		height: '54px',
		mb: 4
	}
};
